import { render, staticRenderFns } from "./eds-iit-checkbox-key-info.vue?vue&type=template&id=6e31c068&scoped=true&lang=pug"
import script from "./eds-iit-checkbox-key-info.vue?vue&type=script&lang=js"
export * from "./eds-iit-checkbox-key-info.vue?vue&type=script&lang=js"
import style0 from "./eds-iit-checkbox-key-info.vue?vue&type=style&index=0&id=6e31c068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e31c068",
  null
  
)

export default component.exports